var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.637528 0.387467C0.521648 0.503109 0.429714 0.640469 0.366987 0.791686C0.30426 0.942903 0.271973 1.10501 0.271973 1.26872C0.271973 1.43243 0.30426 1.59453 0.366987 1.74575C0.429714 1.89696 0.521648 2.03432 0.637528 2.14997L5.48753 6.99997L0.637528 11.85C0.403806 12.0837 0.272502 12.4007 0.272502 12.7312C0.272502 13.0617 0.403806 13.3787 0.637528 13.6125C0.87125 13.8462 1.18824 13.9775 1.51878 13.9775C1.84931 13.9775 2.16631 13.8462 2.40003 13.6125L8.13753 7.87497C8.25341 7.75932 8.34534 7.62196 8.40807 7.47075C8.4708 7.31953 8.50308 7.15743 8.50308 6.99372C8.50308 6.83001 8.4708 6.6679 8.40807 6.51669C8.34534 6.36547 8.25341 6.22811 8.13753 6.11247L2.40003 0.374966C1.92503 -0.100034 1.12503 -0.100033 0.637528 0.387467Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.f35cbe4fcb10052b3ec8da412cc3391e.svg";
export { ForwardRef as ReactComponent };